import { InvestorTransfersTable } from "features/investor-transfer/InvestorTransferTable";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const CommitmentsTabTransfers: React.FC = () => {
  const { fundFamilyId } = useRequiredStringParams();

  const transferCreatePath = rootRoute({})
    .fundFamilies({})
    .fundFamily({ fundFamilyId })
    .investorTransfers({})
    .create({}).$;

  return (
    <PageTabBody>
      <InvestorTransfersTable
        fundFamilyId={fundFamilyId}
        transferCreatePath={transferCreatePath}
      />
    </PageTabBody>
  );
};
